import React, { useEffect, useState } from "react";

//components
import ClustersListContent from "./ClustersListContent";
import Spinner from "../../components/console/Spinner";

//helper functions
import { getClusters } from "./helpers";

const ClustersList = () => {
  // to save the clusters list on page load
  const [clusters, setClusters] = useState(null);

  useEffect(() => {
    //fetches list of clusters from API
    getClusters(setClusters);

    window.scrollTo(0, 0);
  }, []);

  if (clusters !== null) {
    return (
      <ClustersListContent clusters={clusters} setClusters={setClusters} />
    );
  } else {
    return <Spinner />;
  }
};

export default ClustersList;
